
// core components
import React from "react";
import StatusPageHeader from "../../../components/Headers/StatusPageHeader";

class Status403Page extends React.Component {
  render() {
    return (
      <>
        <StatusPageHeader
          title="403!"
          lead="Unauthorised! You are not authorised to access this page."
          btnURL="/"
        />
      </>
    );
  }
}

export default Status403Page;
